import { FC } from 'react';
import { useInput, Props } from './useInput';
import styles from './Input.module.css';

export const Input: FC<Props> = (props) => {
  const { name, type, value, defaultValue, onChange, onClick, inputRef } =
  useInput(props);

  return (
    <input
      name={name}
      type={type}
      className={styles.input}
      onChange={onChange}
      onClick={onClick}
      value={value}
      defaultValue={defaultValue}
      ref={inputRef} />);


};